import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Presentation } from "lucide-react";
import { DECKS } from "../data/content";
import { LineReveal, Rise } from "./motion/Reveal";

export const Decks = () => {
  const [active, setActive] = useState(DECKS[0]);

  return (
    <section id="decks" data-testid="decks-section" className="relative mx-auto max-w-[1400px] px-5 py-28 md:px-12 md:py-40">
      <div className="orb bg-violet" style={{ width: 440, height: 440, top: "10%", right: "5%", opacity: 0.12 }} />

      <div className="mb-14 flex items-end justify-between gap-4">
        <div>
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.3em] text-electric">(Presentation Decks)</p>
          <h2 className="font-display text-5xl font-extrabold uppercase tracking-tighter md:text-8xl">
            <LineReveal lines={["Decks"]} />
          </h2>
        </div>
        <span className="hidden font-mono text-xs uppercase tracking-[0.3em] text-white/40 md:block">({String(DECKS.length).padStart(2, "0")} Presentations)</span>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        {/* Deck selector */}
        <div className="lg:col-span-4">
          <div className="flex flex-col gap-2">
            {DECKS.map((d, i) => {
              const isActive = active.id === d.id;
              return (
                <Rise key={d.id} delay={i * 0.05}>
                  <button
                    data-testid={`deck-tab-${d.id}`}
                    onClick={() => setActive(d)}
                    className="group relative w-full overflow-hidden rounded-2xl border border-white/10 p-5 text-left transition-colors hover:border-electric/40"
                  >
                    {isActive && (
                      <motion.span
                        layoutId="deck-active"
                        className="absolute inset-0 bg-white/[0.04]"
                        transition={{ type: "spring", stiffness: 400, damping: 34 }}
                      />
                    )}
                    <div className="relative flex items-start justify-between gap-4">
                      <div>
                        <span className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-electric">{d.tag}</span>
                        <h3 className={`mt-1.5 font-heading text-lg font-semibold leading-snug transition-colors ${isActive ? "text-cream" : "text-white/70 group-hover:text-cream"}`}>
                          {d.title}
                        </h3>
                      </div>
                      <ArrowUpRight
                        size={18}
                        className={`shrink-0 transition-all ${isActive ? "text-electric" : "text-white/30 group-hover:text-electric"}`}
                      />
                    </div>
                  </button>
                </Rise>
              );
            })}
          </div>
        </div>

        {/* Active deck embed */}
        <div className="lg:col-span-8">
          <div className="glass overflow-hidden rounded-2xl p-2 shadow-[0_40px_120px_-30px_rgba(138,43,226,0.25)]">
            <div className="relative overflow-hidden rounded-xl bg-ink" style={{ paddingTop: "56.25%" }}>
              <AnimatePresence mode="wait">
                <motion.iframe
                  key={active.id}
                  title={active.title}
                  src={active.embed}
                  loading="lazy"
                  allowFullScreen
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.4 }}
                  className="absolute inset-0 h-full w-full"
                  style={{ border: "none" }}
                />
              </AnimatePresence>
            </div>
          </div>
          <div className="mt-4 flex items-center gap-2 px-1 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/40">
            <Presentation size={14} className="text-electric" /> Now viewing · {active.title}
          </div>
        </div>
      </div>
    </section>
  );
};
